import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IBomPart } from 'bom/types';
import { Button } from 'core/components';
import { Color, Variant } from 'theme/enums';

import { ManageElements } from './ManageElements';

interface IProps {
  bomPart: IBomPart;
  isOpenExternal?: boolean;
  updateIsOpenExternal?: (isOpen: boolean) => void;
}

export const ManageElementsButton = ({
  bomPart,
  isOpenExternal = false,
  updateIsOpenExternal = null,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpenExternal) {
      setIsOpen(true);
    }
  }, [isOpenExternal]);

  const { t } = useTranslation();

  const handleOnClose = () => {
    setIsOpen(false);
    updateIsOpenExternal && updateIsOpenExternal(false);
  };

  return (
    <>
      <Button
        text={t('buttonLabelManageElements')}
        color={Color.PRIMARY}
        variant={Variant.PLAIN}
        onClick={() => setIsOpen(true)}
      />

      <ManageElements isOpen={isOpen} onClose={handleOnClose} bomPart={bomPart} />
    </>
  );
};
